export class locations {
    locationId: any;
    warehouseId: any;
    storageLocationId: any;
    StorageLocationIds:any;
}